'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = applyDefaults;

var _Defaults = require('conversations-schema/constants/Defaults');

function applyDefaults(method, url, data) {
  return method(url, _extends({
    timeout: _Defaults.DEFAULT_HTTP_TIMEOUT_IN_MS
  }, data));
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/http/applyDefaults.js
// module id = 155
// module chunks = 0 1